
import makerjs from "makerjs";

function C24(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
  R = Param[0].param,R1 = Param[1].param, R2 = Param[2].param,  
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    r1 = R1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    r = R * 1 * myZoom,
    h=2*r,w=2*r,
    /**
     * sin30=1/2 cos30=Math.sqrt(3)/2
     * 
     */
    rd=r/Math.sqrt(2),
    rxd=r*Math.sqrt(3)/2,
    ryd=r/2,    
    rd1=r1/Math.sqrt(2),
    
    x0 = r-r1,  y0 =r-Math.sqrt((r*r)-(r1*r1)),
    x1 = r-r*Math.sqrt(3)/2-r1*1/2, y1 = r*1/2-r1*Math.sqrt(3)/2+r,
    x2 = r1,  y2 =r*1/2+r1*Math.sqrt(3)/2+r, 
    x3 = 2*r-r1,  y3 = r*1/2+r1*Math.sqrt(3)/2+r,
    x4 = r+r*Math.sqrt(3)/2+r1*1/2,  y4 = r*1/2-r1*Math.sqrt(3)/2+r,
    x5 = r+r1,  y5 = r-Math.sqrt((r*r)-(r1*r1)),
    
     glassH = h, glassW = w;
 
console.log("x1,y1,x2,y2,x3,y3,x4,y4,x5,y5,x0,y0,r,r1===",x1,y1,x2,y2,x3,y3,x4,y4,x5,y5,x0,y0,r,r1)
     if (r1 !== 0) {
      var TxtR1 = "R1=" +R1;
    } if (r2 !== 0) {
      var TxtR2 = "R2=" +R2;
    } if (r !== 0) {
    var TxtR ="R=" + R;
  } 



  var drawAbnormalShapeC24 = {
    paths: {
      "LeftLBottomBigArc": new makerjs.paths.Arc([x0, y0], [x1, y1], r, false, true),
      "LeftUpSmallArc": new makerjs.paths.Arc([x1, y1], [x2, y2], r1, false, false),
      "TopBigArc": new makerjs.paths.Arc([x2, y2], [x3, y3], r, false, true),
      "RightUpSmallArc": new makerjs.paths.Arc([x3, y3], [x4, y4], r1, false, false),
      "RightBottomBigArc": new makerjs.paths.Arc([x4, y4], [x5, y5], r, false, true),      
      "BottomSmallArc": new makerjs.paths.Arc([x5, y5], [x0, y0], r1, false, false), 
    }
  };

  var fillet1 = makerjs.path.fillet(drawAbnormalShapeC24.paths.LeftLBottomBigArc, drawAbnormalShapeC24.paths.LeftUpSmallArc, r2);
  var fillet2 = makerjs.path.fillet(drawAbnormalShapeC24.paths.LeftUpSmallArc, drawAbnormalShapeC24.paths.TopBigArc, r2);
  var fillet3 = makerjs.path.fillet(drawAbnormalShapeC24.paths.TopBigArc, drawAbnormalShapeC24.paths.RightUpSmallArc, r2);
  var fillet4 = makerjs.path.fillet(drawAbnormalShapeC24.paths.RightUpSmallArc, drawAbnormalShapeC24.paths.RightBottomBigArc, r2);
  var fillet5 = makerjs.path.fillet(drawAbnormalShapeC24.paths.RightBottomBigArc, drawAbnormalShapeC24.paths.BottomSmallArc, r2);
  var fillet6 = makerjs.path.fillet(drawAbnormalShapeC24.paths.BottomSmallArc, drawAbnormalShapeC24.paths.LeftLBottomBigArc, r2);
  // var arc2 = makerjs.path.fillet(myButterflyGap4.paths.arc, myButterflyGap4.paths.line, 5);
//add the fillet to the model
drawAbnormalShapeC24.paths.fillet1 = fillet1;
drawAbnormalShapeC24.paths.fillet2 = fillet2;
drawAbnormalShapeC24.paths.fillet3 = fillet3;
drawAbnormalShapeC24.paths.fillet4 = fillet4;
drawAbnormalShapeC24.paths.fillet5 = fillet5;
drawAbnormalShapeC24.paths.fillet6 = fillet6;

  var drawAbnormalShapeC24MarkR = {
    paths: {
      "BottomLine": new makerjs.paths.Line([r, r], [r+rd, r-rd]),
    }
  };
  var drawAbnormalShapeC24MarkR1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([r, y0+r1], [r, y0]),
    }
  };

  var drawAbnormalShapeC24MarkR2 = {
    paths: {
      "UpShortLine": new makerjs.paths.Line([x5+r2, y5+r2/2], [x5+r1/2, y5]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC24MarkR, TxtR, [r-5*markShift, r+markShift], [r-markShift, r+markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC24MarkR1, TxtR1, [r-3*markShift, y0+r1+2*markShift], [r+3*markShift, y0+r1+2*markShift]);//长度文字 
  makerjs.model.addCaption(drawAbnormalShapeC24MarkR2, TxtR2, [x5+r1/2, y5], [x5+r1/2+8*markShift, y5]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC24: drawAbnormalShapeC24,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC24: drawAbnormalShapeC24,
      drawAbnormalShapeC24MarkR: drawAbnormalShapeC24MarkR,
      drawAbnormalShapeC24MarkR1: drawAbnormalShapeC24MarkR1,
      drawAbnormalShapeC24MarkR2: drawAbnormalShapeC24MarkR2,
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C24;